module.exports = __webpack_public_path__ + "img/rightarrow.c5bab472.svg";